import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import resolvePublicAsset from '../utils/resolvePublicAsset';

function Projetos() {
  const projetos = [
    {
      titulo: 'Circuito Paulista de Hip Hop',
      subtitulo: '',
      descricao: 'Circulação cultural com rap, breaking, graffiti, DJs e oficinas formativas em cidades do interior paulista.',
      imagem: resolvePublicAsset('/images/logo_circuito_paulista_hiphop.png'),
      alt: 'Circuito Paulista de Hip Hop',
      to: '/projetos/circuito-paulista-hip-hop',
      acao: 'VER MAIS',
      disponivel: true
    },
    {
      titulo: 'Semana do Hip Hop',
      subtitulo: '',
      descricao: 'Evento anual gratuito em Bauru com shows, batalhas, breaking, grafite, oficinas, debates e foco social.',
      imagem: resolvePublicAsset('/images/semanahiphop/2024/logo.jpg'),
      alt: 'Ação cultural do Instituto Acesso Popular',
      to: '/projetos/semana-do-hip-hop',
      acao: 'VER MAIS',
      disponivel: true
    }
  ];

  return (
    <div className="projects-page">

      <section className="projects-grid-section">
        <Container>
          <Row className="g-4 justify-content-center">
            {projetos.map((projeto) => (
              <Col lg={4} md={6} key={projeto.titulo}>
                <div className={`projects-card${projeto.disponivel ? ' is-available' : ' is-muted'}`}>
                  <div className="projects-card-image">
                    <img src={projeto.imagem} alt={projeto.alt} className="img-fluid" />
                  </div>
                  <div className="projects-card-body">
                    <h3>{projeto.titulo}</h3>
                    <p>{projeto.descricao}</p>
                    {projeto.disponivel ? (
                      <Button as={Link} variant="danger" to={projeto.to} className="projects-button-primary w-100">
                        {projeto.acao}
                      </Button>
                    ) : (
                      <Button variant="outline-dark" disabled className="projects-button-muted w-100">
                        {projeto.acao}
                      </Button>
                    )}
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
    </div>
  );
}

export default Projetos;